import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  campaign as campaignOverviewApi,
  dashboardMetrics as dashboardMetricsApi,
  userMetrics,
  userHourlyMetrics,
} from 'util/Api/metrics';

export const getCampaignOverview = createAsyncThunk(
  'metrics/getCampaignOverview',
  async ({ campaignId, dateRange }, { rejectWithValue }) => {
    try {
      return await campaignOverviewApi({
        campaignId,
        dateRange,
      });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const getDashboardMetrics = createAsyncThunk(
  'metrics/getDashboardMetrics',
  async ({ campaignId, dateRange }, { rejectWithValue }) => {
    try {
      return await dashboardMetricsApi({
        campaignId,
        dateRange,
      });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const getUserMetrics = createAsyncThunk(
  'metrics/getUserMetrics',
  async ({ userId, dateRange }, { rejectWithValue }) => {
    try {
      return await userMetrics({
        userId,
        dateRange,
      });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const getUserMetricsHourly = createAsyncThunk(
  'metrics/getUserMetricsHourly',
  async ({ userId }, { rejectWithValue }) => {
    try {
      return await userHourlyMetrics({
        userId,
      });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);
